<script>
import DataLayer from '@services/data-layer/index'

import ShowScheduleBlock from '@components/show-schedule-block'
import format from 'date-fns/format'
import addDays from 'date-fns/addDays'
import startOfToday from 'date-fns/startOfToday'

export default {
    components: { ShowScheduleBlock },
    page() {
        const channelTitle = this.channel.title || 'Channel'
        const title = `Schedule — ${channelTitle}`
        const description = this.channel.description || `Upcoming show schedule for ${channelTitle}.` || `Upcoming show schedule`
        const image = `${process.env.VUE_APP_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
    data() {
        return {
            dates: [],
            activeDate: {},
            schedule: Array.from(Array(6), (e, i) => ({
                id: i,
                show: {
                    id: i,
                    title: '',
                    url: '',
                    type: 'show',
                    image: {},
                    genre: [],
                    artist_id: [],
                    artist: [],
                },
            })),
        }
    },
    computed: {
        channel() {
            return this.$store.state.channels.channels.find(channel => channel.id === this.$route.params.channelId) || {}
        },
        activeDateLabel() {
            return this.activeDate.label || ''
        },
        dateLabels() {
            return this.dates.map(el => el.label)
        },
        clientTimezoneLabel() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone || 'your local timezone'
        },
    },
    watch: {
        activeDate: {
            handler(val) {
                if (!val.date) {
                    return false
                }
                this.getChannelSchedule(val.date)
            },
        },
    },
    mounted() {
        const date = startOfToday()

        for (let i = 0; i < 7; i++) {
            const newDate = addDays(date, i)
            this.dates.push({
                label: format(newDate, 'd MMM yyyy'),
                date: newDate,
            })
        }

        this.activeDate = this.dates[0]
    },
    methods: {
        handleDateChange(date) {
            this.activeDate = this.dates.find(el => el.label === date)
        },
        getChannelSchedule(date) {
            DataLayer.episodes.getByDate(this.$route.params.channelId, date, addDays(date, 1)).then(episodes => {
                this.schedule = episodes.body
            })
        },
    },
}
</script>

<template>
    <BaseContent>
        <BaseSection
            title="Schedule"
            padded
        >
            <div slot="right">
                <BaseCustomSelect
                    :options="dateLabels"
                    :active="activeDateLabel"
                    prefix="Date:"
                    @change="handleDateChange"
                />
            </div>
            <p :class="$style.timezoneNote">
                Showing times in {{ clientTimezoneLabel }}
            </p>
            <ShowScheduleBlock
                :resources="schedule"
                :error="{ paragraph: 'There are no shows scheduled for this day' }"
            />
        </BaseSection>
    </BaseContent>
</template>

<style lang="scss" module>
@import '@design';

.timezoneNote {
    @extend %contentSubtitleS;

    margin: 0 0 $s-m;
    color: $c-shuttle-gray;
}
</style>
